import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import localization from './Localization.ru';
import { formatDate } from '../../helpers/core';

class CustomDatepicker extends Component {
	constructor (props) {
		super(props);

		this.state = {
			selectedDay: props.selectedDay || null
		}
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps && nextProps.selectedDay !== this.state.selectedDay) {
			this.setState({
				selectedDay: nextProps.selectedDay
			});
		}
	}

	handleDayClick = (day, { selected }) => {
		this.setState({
			selectedDay: selected ? undefined : day
		}, () => this.props.onDayChange(this.state.selectedDay));
	}

	render () {
		const { selectedDay } = this.state;
		const { name, disabledDays } = this.props;

		return <div>
			<DayPickerInput
				placeholder="ДД.ММ.ГГГГ"
				onDayChange={this.handleDayClick}
				name={name}
				value={selectedDay ? formatDate(selectedDay) : ''}
				dayPickerProps={{
					...localization,
					enableOutsideDays: true,
					onDayClick: this.handleDayClick,
					selectedDays: selectedDay,
					disabledDays: disabledDays || []
				}}
			/>
		</div>;
	}
}

CustomDatepicker.propTypes = {
	onDayChange: PropTypes.func,
	selectedDay: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	name: PropTypes.string,
	disabledDays: PropTypes.array
};

CustomDatepicker.defaultProps = {
	onDayChange: () => {}
}

export default CustomDatepicker;



// WEBPACK FOOTER //
// ./components/Datepicker/CustomDatepicker.js